/** Decode HTML entities for display (e.g. legacy journal source titles). */
export function decodeHtmlEntities(text: string): string {
  if (!text) return "";

  let out = text;

  out = out.replace(/&#x([0-9a-f]+);/gi, (_, hex) => {
    try {
      return String.fromCodePoint(parseInt(hex, 16));
    } catch {
      return "";
    }
  });

  out = out.replace(/&#(\d+);/g, (_, dec) => {
    try {
      return String.fromCodePoint(Number(dec));
    } catch {
      return "";
    }
  });

  const named: Record<string, string> = {
    nbsp: " ",
    amp: "&",
    lt: "<",
    gt: ">",
    quot: '"',
    apos: "'",
    ldquo: "\u201C",
    rdquo: "\u201D",
    lsquo: "\u2018",
    rsquo: "\u2019",
    mdash: "\u2014",
    ndash: "\u2013",
    hellip: "\u2026",
  };

  out = out.replace(/&([a-z]+);/gi, (match, name: string) => named[name.toLowerCase()] ?? match);

  return out;
}

export function cleanSocialSourceTitle(raw: string): string {
  const decoded = decodeHtmlEntities(raw).trim();
  const igMatch = decoded.match(/^(.+?)\s+on Instagram:\s*(.+)$/is);
  if (igMatch) {
    let caption = igMatch[2].trim().replace(/^["']+|["']+$/g, "").trim();
    if (caption.length > 0) return caption;
  }

  const tiktokMatch = decoded.match(/^(.+?)\s+on TikTok:\s*(.+)$/is);
  if (tiktokMatch) return tiktokMatch[2].trim();

  return decoded;
}
